import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import vuetify from "./plugins/vuetify";
import VueResource from "vue-resource";
import jquery from "jquery";

Vue.use(VueResource);
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.withCredentials = true;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

const ignoreWarnMessage =
  "The .native modifier for v-on is only valid on components but it was used on <div>.";
Vue.config.warnHandler = function(msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};

// This function checks if the session expiration dialogue is currently showing.
// It also forces the user to click either the continue or logout buttons,
// rather than refreshing timers if they click on the dialogue.
function userAction() {
  var expire_dialogue = document.getElementById("session-expire-dialogue");
  var expire_dialogue_hidden = true;

  // Check if the session expiration dialogue is currently hidden or not.
  if (expire_dialogue !== null) {
    expire_dialogue_hidden = expire_dialogue.classList.contains("hide");
  }

  // List of pages to ignore for refreshing timers.
  const ignoreRefreshPaths = ["/login", "/reg-pay-sch-link"];

  // If the user is on an ignore page path or the session expiration dialogue is not hidden,
  // return without refreshing the timers.
  var currentPath = window.location.pathname;
  if (ignoreRefreshPaths.includes(currentPath) || expire_dialogue_hidden) {
    return;
  }

  // If none of the above conditions are met, refresh the timers by dispatching the "refreshSessionTimers" action.
  console.log("autoLogout: user action detected -> refreshSessionTimers");
  store.dispatch("refreshSessionTimers").autoLogoutModule;
}

// Add an event listener to detect any click on the page.
// If a click is detected, call the "userAction" function to refresh the session timers.
document.addEventListener("click", userAction);

// add jquery to DOM
window.$ = window.jQuery = jquery;
